module.exports = __webpack_public_path__ + "img/p1.2a243647.png";